import PageRenderer from "./templates/PageTemplate";

export default function Main() {

  // Stany trzech modalów




  return (
    <>
      <PageRenderer />
    </>
  );
}